import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { UserSettingsData } from '../api/types';
import config from '../config';

async function getSettings(axios: AxiosInstance): Promise<UserSettingsData> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/settings`);
  return data;
}

export default function useSettingsQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getSettings(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['Settings'] as const satisfies QueryKey;
}
useSettingsQuery.getKey = getKey;
